import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ZalamoObject } from '../../../../../graphql';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';

@Component({
    selector: 'app-look-book-visited-by-client',
    templateUrl: './look-book-visited-by-client.component.html',
    styleUrls: ['./look-book-visited-by-client.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LookBookVisitedByClientComponent implements OnInit {
  ob: ZalamoObject = ZalamoObject.OrganizationClient;
  thumbs: Array<string>;

  private _details: UserWallEvent[UserWallEventType.LookBookOrderPlaced];

  get details(): UserWallEvent[UserWallEventType.LookBookOrderPlaced] {
    return this._details;
  }

  @Input()
  @ParseJson
  set details(value: UserWallEvent[UserWallEventType.LookBookOrderPlaced]) {
    this._details = value;
    this.thumbs = this._details.thumbs.slice(0, 3);
  }

  constructor() {}

  ngOnInit(): void {}
}
